const config = {
  apiURL: import.meta.env.VITE_API_BASE_URL,
};

export default config;
